<section class="py-16 bg-[#0B0F17]">
  <app-content-container>
    <div class="text-center max-w-4xl mx-auto">
      <span
        class="inline-block px-3 py-1 mb-4 text-xs font-semibold tracking-wider text-primary uppercase bg-primary/10 rounded-full border border-primary/20"
      >
        LGPD &middot; Lei n&ordm; 13.709/2018
      </span>
      <h1 class="text-3xl md:text-5xl font-bold pb-4 text-white">
        Pol&iacute;tica de <span class="text-primary">Privacidade</span>
      </h1>
      <p
        class="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed"
      >
        Saiba como a Code Dimension protege sua privacidade, trata dados
        pessoais e respeita suas escolhas de cookies.
      </p>
      <p class="text-xs text-slate-400 mt-4">
        &Uacute;ltima atualiza&ccedil;&atilde;o: Novembro de 2026
      </p>
    </div>
  </app-content-container>
</section>

<section class="page-section pb-20 pt-4">
  <app-content-container>
    <article class="max-w-4xl mx-auto space-y-8 text-slate-300 leading-relaxed">
      <!-- 1. Controlador e Finalidade -->
      <div
        class="bg-base-100/50 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl"
      >
        <h2
          class="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-2"
        >
          <span class="text-primary">1.</span> Identifica&ccedil;&atilde;o do
          Controlador e Finalidade
        </h2>
        <p class="mb-4">
          A <strong class="text-white">Code Dimension</strong>, fundada por
          Henrique Cust&oacute;dia em 2023, &eacute; uma plataforma educacional
          dedicada ao ensino, forma&ccedil;&atilde;o e aperfei&ccedil;oamento
          t&eacute;cnico em desenvolvimento Front-End e ecossistema Angular no
          Brasil.
        </p>
        <p>
          Para os fins da Lei Geral de Prote&ccedil;&atilde;o de Dados (LGPD
          &ndash; Lei n&ordm; 13.709/2018), a Code Dimension atua como
          <strong class="text-white">Controladora</strong> dos dados coletados
          durante sua navega&ccedil;&atilde;o em nosso website institucional e
          intera&ccedil;&otilde;es educacionais. Nosso compromisso &eacute;
          garantir total transpar&ecirc;ncia, integridade e confian&ccedil;a em
          todas as rela&ccedil;&otilde;es com nossos alunos, visitantes e
          membros da comunidade.
        </p>
      </div>

      <!-- 2. Categorias de Cookies -->
      <div
        class="bg-base-100/50 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl"
      >
        <h2
          class="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-2"
        >
          <span class="text-primary">2.</span> Dados Coletados e Categorias de
          Cookies
        </h2>
        <p class="mb-4">
          Cookies s&atilde;o pequenos arquivos de texto armazenados no seu
          navegador para registrar prefer&ecirc;ncias e par&acirc;metros
          t&eacute;cnicos. Em nosso portal, dividimos o uso de tecnologias de
          armazenamento em duas categorias fundamentais:
        </p>
        <div class="space-y-4">
          <div class="p-4 rounded-xl bg-white/5 border border-white/5">
            <h3
              class="text-lg font-semibold text-white mb-2 flex items-center gap-2"
            >
              <i class="bi bi-shield-check text-success"></i> Cookies
              Estritamente Necess&aacute;rios
            </h3>
            <p class="text-sm">
              S&atilde;o indispens&aacute;veis para que o website funcione de
              maneira segura e est&aacute;vel. Incluem a seguran&ccedil;a de
              sess&atilde;o, controle de layout responsivo e o registro da sua
              pr&oacute;pria decis&atilde;o de privacidade por meio do
              armazenamento local (<code
                class="text-primary px-1.5 py-0.5 bg-black/40 rounded"
                >localStorage</code
              >
              com a chave
              <code class="text-primary px-1.5 py-0.5 bg-black/40 rounded"
                >cd_cookie_consent</code
              >). Esses recursos operam sem exigir consentimento
              espec&iacute;fico, pois viabilizam o funcionamento t&eacute;cnico
              prim&aacute;rio do portal e n&atilde;o rastreiam seu comportamento
              para fins de publicidade.
            </p>
          </div>

          <div class="p-4 rounded-xl bg-white/5 border border-white/5">
            <h3
              class="text-lg font-semibold text-white mb-2 flex items-center gap-2"
            >
              <i class="bi bi-graph-up text-primary"></i> Cookies
              Anal&iacute;ticos e Estat&iacute;sticos
            </h3>
            <p class="text-sm">
              Utilizados para compreender o fluxo de navega&ccedil;&atilde;o,
              audi&ecirc;ncia das p&aacute;ginas e engajamento da comunidade
              (como Google Tag Manager e Google Analytics). Essas
              informa&ccedil;&otilde;es s&atilde;o analisadas de forma agregada
              para aprimorar continuamente nossos conte&uacute;dos e
              treinamentos. Tais cookies e scripts de medi&ccedil;&atilde;o
              <strong class="text-white"
                >somente s&atilde;o ativados mediante sua
                autoriza&ccedil;&atilde;o pr&eacute;via expressa</strong
              >.
            </p>
          </div>
        </div>
      </div>

      <!-- 3. Google Consent Mode v2 -->
      <div
        class="bg-base-100/50 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl"
      >
        <h2
          class="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-2"
        >
          <span class="text-primary">3.</span> Mecanismo de Consentimento e
          Google Consent Mode v2
        </h2>
        <p class="mb-4">
          Adotamos o princ&iacute;pio da
          <strong class="text-white"
            >Privacidade por Padr&atilde;o (Privacy by Default)</strong
          >. Ao carregar nosso website pela primeira vez, os par&acirc;metros de
          rastreamento do Google Consent Mode v2 s&atilde;o inicializados como
          <code class="text-warning px-1.5 py-0.5 bg-black/40 rounded"
            >denied</code
          >
          (negados) para armazenamento anal&iacute;tico e de an&uacute;ncios:
        </p>
        <ul class="list-disc list-inside space-y-2 mb-4 text-sm pl-2">
          <li>
            <code class="text-slate-200">analytics_storage</code>: bloqueado
            at&eacute; autoriza&ccedil;&atilde;o expressa.
          </li>
          <li>
            <code class="text-slate-200">ad_storage</code>,
            <code class="text-slate-200">ad_user_data</code>,
            <code class="text-slate-200">ad_personalization</code>: bloqueados
            por padr&atilde;o.
          </li>
        </ul>
        <p class="mb-4">
          Atrav&eacute;s do di&aacute;logo de consentimento localizado no
          rodap&eacute; da p&aacute;gina, voc&ecirc; pode optar por:
        </p>
        <ul class="list-disc list-inside space-y-2 mb-4 text-sm pl-2">
          <li>
            <strong class="text-white">Aceitar todos:</strong> Autoriza o
            disparo de tags anal&iacute;ticas, atualizando o estado do Google
            Consent Mode para
            <code class="text-success px-1.5 py-0.5 bg-black/40 rounded"
              >granted</code
            >.
          </li>
          <li>
            <strong class="text-white">Apenas essenciais:</strong> Mant&eacute;m
            todos os scripts e cookies anal&iacute;ticos desativados (<code
              class="text-warning px-1.5 py-0.5 bg-black/40 rounded"
              >denied</code
            >), persistindo a escolha para n&atilde;o exibir mais o aviso.
          </li>
        </ul>
        <div
          class="p-4 rounded-xl bg-primary/10 border border-primary/20 text-sm"
        >
          <h4 class="font-semibold text-white mb-1 flex items-center gap-1.5">
            <i class="bi bi-arrow-repeat text-primary"></i> Como redefinir ou
            revogar suas prefer&ecirc;ncias
          </h4>
          <p>
            Voc&ecirc; tem a liberdade de alterar ou revogar sua escolha a
            qualquer momento. Basta limpar os cookies e dados de
            navega&ccedil;&atilde;o ou remover a chave
            <code class="text-primary px-1 py-0.5 bg-black/40 rounded"
              >cd_cookie_consent</code
            >
            no armazenamento local do seu navegador. Ao recarregar o website, o
            di&aacute;logo de consentimento ser&aacute; novamente apresentado
            para sua escolha.
          </p>
        </div>
      </div>

      <!-- 4. Direitos do Titular (Art. 18 LGPD) -->
      <div
        class="bg-base-100/50 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl"
      >
        <h2
          class="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-2"
        >
          <span class="text-primary">4.</span> Seus Direitos (LGPD &ndash;
          Artigo 18)
        </h2>
        <p class="mb-4">
          Como titular de dados pessoais, a legisla&ccedil;&atilde;o brasileira
          assegura que voc&ecirc; possa exercer os seguintes direitos mediante
          requisi&ccedil;&atilde;o direta:
        </p>
        <ol class="list-decimal list-inside space-y-2 text-sm pl-2">
          <li>
            <strong class="text-white"
              >Confirma&ccedil;&atilde;o da exist&ecirc;ncia de
              tratamento:</strong
            >
            saber se realizamos tratamento dos seus dados.
          </li>
          <li>
            <strong class="text-white">Acesso aos dados:</strong> requisitar
            c&oacute;pia das informa&ccedil;&otilde;es sob nosso controle.
          </li>
          <li>
            <strong class="text-white">Corre&ccedil;&atilde;o de dados:</strong>
            solicitar a atualiza&ccedil;&atilde;o de dados incompletos, inexatos
            ou desatualizados.
          </li>
          <li>
            <strong class="text-white"
              >Anonimiza&ccedil;&atilde;o, bloqueio ou
              elimina&ccedil;&atilde;o:</strong
            >
            aplic&aacute;veis a dados desnecess&aacute;rios, excessivos ou em
            desconformidade legal.
          </li>
          <li>
            <strong class="text-white">Portabilidade dos dados:</strong> obter
            seus dados em formato estruturado para migra&ccedil;&atilde;o a
            outro fornecedor, observados os segredos comercial e industrial.
          </li>
          <li>
            <strong class="text-white"
              >Elimina&ccedil;&atilde;o dos dados pessoais:</strong
            >
            requerer o descarte de dados tratados com base em consentimento,
            salvo exce&ccedil;&otilde;es legais de guarda.
          </li>
          <li>
            <strong class="text-white"
              >Informa&ccedil;&otilde;es sobre compartilhamento:</strong
            >
            saber com quais entidades p&uacute;blicas ou privadas houve
            compartilhamento de dados.
          </li>
          <li>
            <strong class="text-white"
              >Informa&ccedil;&atilde;o sobre a negativa de
              consentimento:</strong
            >
            esclarecimentos sobre as consequ&ecirc;ncias de n&atilde;o fornecer
            determinada autoriza&ccedil;&atilde;o.
          </li>
          <li>
            <strong class="text-white"
              >Revoga&ccedil;&atilde;o do consentimento:</strong
            >
            retirar qualquer consentimento previamente concedido de forma
            simples e facilitada.
          </li>
        </ol>
      </div>

      <!-- 5. Seguranca e Retencao -->
      <div
        class="bg-base-100/50 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl"
      >
        <h2
          class="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-2"
        >
          <span class="text-primary">5.</span> Seguran&ccedil;a da
          Informa&ccedil;&atilde;o e Reten&ccedil;&atilde;o
        </h2>
        <p class="mb-4">
          Adotamos medidas t&eacute;cnicas e organizacionais adequadas para
          proteger seus dados contra acessos n&atilde;o autorizados,
          destrui&ccedil;&atilde;o, perda ou altera&ccedil;&atilde;o acidental.
          Todo o tr&aacute;fego de rede &eacute; protegido por criptografia de
          ponta a ponta via protocolo HTTPS/TLS.
        </p>
        <p>
          Transa&ccedil;&otilde;es comerciais e de pagamento relativas a cursos
          e assinaturas s&atilde;o processadas de forma segura por meio de
          plataformas parceiras especializadas (como a Hotmart), as quais
          mant&ecirc;m suas pr&oacute;prias pol&iacute;ticas e
          certifica&ccedil;&otilde;es de seguran&ccedil;a (como PCI-DSS).
        </p>
      </div>

      <!-- 6. Canal de Contato e DPO -->
      <div
        class="bg-base-100/50 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 shadow-xl"
      >
        <h2
          class="text-xl md:text-2xl font-bold text-white mb-4 flex items-center gap-2"
        >
          <span class="text-primary">6.</span> Canal de Contato e Encarregado de
          Dados (DPO)
        </h2>
        <p class="mb-4">
          Para exercer quaisquer dos seus direitos previstos na LGPD, esclarecer
          d&uacute;vidas ou enviar coment&aacute;rios sobre esta Pol&iacute;tica
          de Privacidade, entre em contato diretamente com o nosso Encarregado
          pelo Tratamento de Dados Pessoais (DPO):
        </p>
        <div
          class="p-4 rounded-xl bg-white/5 border border-white/10 flex flex-col sm:flex-row sm:items-center justify-between gap-4"
        >
          <div>
            <p class="text-sm text-slate-400">
              Canal oficial de atendimento LGPD:
            </p>
            <p class="text-base font-semibold text-white">
              Code Dimension &ndash; Privacidade e Dados
            </p>
          </div>
          <a
            href="mailto:contato@codedimension.com.br"
            class="btn btn-primary btn-sm sm:btn-md"
          >
            <i class="bi bi-envelope-fill mr-1"></i>
            contato&#64;codedimension.com.br
          </a>
        </div>
      </div>
    </article>
  </app-content-container>
</section>
